import { SET_SELECTED_TAB, SAVE_SELECTED_TAB } from "../ActionTypes/index";

export const setSelectedTab = (tab) => ({
  type: SET_SELECTED_TAB,
  payload: tab,
});

export const saveSelectedTab = (tab) => ({
  type: SAVE_SELECTED_TAB,
  payload: tab,
});
